<template>
  <div class="accordion">
    <slot>
      <div class="item__box" v-for="(item, i) of list" :key="i">
        <div
            class="item__content"
            :class="[`item__content${i}`, { 'item__content-active': activeIndex === i }]"
        >
          <div class="item__content__detail">
            <img
                :src="item.src"
                alt=""
            />
            <div class="item">
              <div class="item_title">{{ item.title }}</div>
              <div class="item_desc"><i class="el-icon-check"></i><div class="desc_text">{{ item.title_1 }}</div></div>
              <div class="item_desc"><div class="desc_text2">{{ item.desc_1 }}</div></div>
              <div class="item_desc"><i class="el-icon-check"></i><div class="desc_text">{{ item.title_2 }}</div></div>
              <div class="item_desc"><div class="desc_text2">{{ item.desc_2 }}</div></div>
              <div class="item_desc" v-if="item.title_3"><i class="el-icon-check"></i><div class="desc_text">{{ item.title_3 }}</div></div>
              <div class="item_desc" v-if="item.title_3"><div class="desc_text2">{{ item.desc_3 }}</div></div>
<!--              <div class="tag-area">-->
<!--                <el-tag-->
<!--                    v-for="(tagItem,index) in item.tags"-->
<!--                    :key="index"-->
<!--                    type="info"-->
<!--                    size="mini"-->
<!--                    class="tag"-->
<!--                    effect="plain">-->
<!--                  {{ tagItem }}-->
<!--                </el-tag>-->
<!--              </div>-->

              <div class="btn-more">
                <a href="/Experience" class="a1"><el-button type="primary" class="btn">立即咨询</el-button></a>
<!--                <a href="/BusinessPartner" class="a2"><el-button class="btn">了解更多</el-button></a>-->
              </div>
            </div>
          </div>
        </div>
        <div
            class="item__title"
            :class="[`item__title${i}`, { 'item__title-active': activeIndex === i }]"
        >
          <div class="item__title__detail" @click="() => tabChange(i)">
            <img
                :src="item.src"
                alt=""
            />
            <slot :name="`item__title${i}`">
              <div class="item__title__detail__text item__title__detail_add">{{ item.title }}</div>
              <div class="item__title__detail__text item__title__detail_add1"><i class="el-icon-check"></i>{{ item.title_1 }}</div>
              <div class="item__title__detail__text item__title__detail_add1"><i class="el-icon-check"></i>{{ item.title_2 }}</div>
              <div class="item__title__detail__text item__title__detail_add1" v-if="item.title_3"><i class="el-icon-check"></i>{{ item.title_3 }}</div>
            </slot>
          </div>
        </div>
      </div>
    </slot>
  </div>
</template>
<script>
// import { reactive, toRefs, onBeforeMount, onMounted, ref } from 'vue'
// import { getImageUrl } from '@/untils/index'
export default {
  name: 'Accordion',
  data() {
    return {
      activeIndex: 0,
      list: [
        {
          // icon: 'icon/icon_edu_gk.png',
          // activeIcon: 'icon/icon_edu_gk_active.png',
          title: '数智化转型咨询',
          title_1: '战略规划',
          desc_1: '行业痛点诊断+技术路线设计，量身定制转型蓝图！',
          title_2: '场景赋能',
          desc_2: 'AI/大数据/物联网融合方案，驱动业务与数据价值双提升！',
          title_3: '落地陪跑',
          desc_3: '从顶层设计到执行路径，全程护航转型进程！',
          src: require('@/assets/img/product/service1.png'),
        },{
          // icon: 'icon/icon_edu_gk.png',
          // activeIcon: 'icon/icon_edu_gk_active.png',
          title: '软件定制开发',
          title_1: '需求开发',
          desc_1: 'ERP/数据分析/物联网平台，打造专属数字化引擎！',
          title_2: '敏捷交付',
          desc_2: '快速迭代+自动化测试，缩短业务上线周期！',
          title_3: '',
          desc_3: ' ',
          src: require('@/assets/img/product/service2.png'),
         },

        {
          // icon: 'icon/icon_edu_nj.png',
          // activeIcon: 'icon/icon_edu_nj_active.png',
          title: '数据中心建设',
          title_1: '智能基座',
          desc_1: '模块化机房+绿色节能设计，构建高可用算力底座！',
          title_2: '全链集成',
          desc_2: '从规划到运维，资源池化+灾备方案，保障业务连续性！',
          title_3: '',
          desc_3: ' ',
          src: require('@/assets/img/product/service3.png'),

        }
      ]
    }
  },
  methods: {
    tabChange(index) {
      this.activeIndex = index
    }
  }
}
// interface Item {
//   icon?: string
//   activeIcon?: string
//   title: string
// }

// defineProps({
//   list: {
//     type: Array,
//     default: () => []
//   }
// })

</script>
<style lang="scss" scoped>
.accordion {
  position: relative;
  width: 70%;
  margin: 20px auto;
  height: 500px;
  display: flex;
  color: #fff;
  //background: url('@/assets/images/bg_shoufq.png');
  overflow: hidden;
}
.item__box {
  position: relative;
  display: flex;
  overflow: hidden;
  margin-left: 4px;
}
.item__content {
  flex-shrink: 0;
  width: 8px;
  left: 30%;
  overflow: hidden;
  border-radius: 4px;
  transition: all 0.5s ease;
  //box-shadow: 10px 10px 10px 2px rgba(12, 28, 56, 0.18);

}
.item__title {
  width: 380px;
  flex-shrink: 0;
  border-radius: 4px;
  //box-shadow: 10px 10px 10px 2px rgba(12, 28, 56, 0.18);

}
.item__content__detail {
  width: 540px;
  height: 500px;
  border-radius: 4px;
  opacity: 0;
  transition: opacity 0.5s ease;

}
.item__content-active {
  width: 540px;
  margin-left: 8px;
  border-radius: 4px;
  left: 0;
  .item__content__detail {
    display: flex;
    width: 540px;
    opacity: 1;
    background-color: #fff;
    .item{
      padding: 30px 20px;position: relative;z-index: 1;height: 100%;
      .tag-area{
        text-align: left;padding-top: 50px;padding-left: 10px;
        .tag{
          margin: 4px;font-size: 12px
        }
      }
      .btn-more{
        position: absolute;
        bottom: 40px;
        align-items: center;
        display: flex;
        padding-left: 20px;
        .a1{
          color: #fff;
          margin-right: 20px;
          .btn{
            background-color: rgba(0, 82, 217, 1);
            width: 170px;
            padding: 10px;
          }
        }
        .a2{
          color: #fff;
          .btn{
            width: 170px;
            padding: 10px
          }
        }
      }
    }

    img {
      position: absolute;
      width: 538px;
      height: 100%;
      border-radius: 4px;
      //border: 2px solid #fff;
      object-fit: cover; /* 或者使用contain, fill, none, scale-down等值 */
      object-position:85% 100%; /* 默认值，可以根据需要调整x和y坐标 */
      opacity: 0.4;
      z-index: 0;
    }
    .item_title {
      transition: all 0.5s;
      font-size: 22px;
      font-weight: bold;
      color: #05102F;
      text-align: left;
      padding: 20px 0 10px 20px;
      z-index: 2;
      position: inherit;
      margin-bottom: 10px;
      @media screen and (max-width: 768px) {
        font-size: 1rem;
        text-align: center;
      }
    }
    .item_desc {
      transition: all 0.5s;
      color: #666;
      text-align: left;
      line-height: 20px;
      z-index: 2;
      position: inherit;
      font-size: 12px;
      min-height: 34px;
      padding-left: 20px;
      @media screen and (max-width: 768px) {
        min-height: 110PX;
        text-indent: 2em;
        font-size: 12px;
      }
      i{
        padding-right: 5px;
        color: #0052D9;
        font-weight: bold;
        float: left;
      }
      .desc_text{
        margin-left: 10px;
        float: left;
        font-size: 15px;
        color: rgba(5, 16, 47, 1);
      }
      .desc_text2{
        float: left;
        margin-top: 0;
        font-size: 13px;
        margin-left: 28px;
        color: rgba(5, 16, 47, 0.5);
      }

    }
  }
}

.item__title__detail {
  display: flex;
  flex-direction: column;
  //justify-content: center;
  //align-items:start;
  text-align: left;
  width: 100%;
  height: 500px;
  cursor: pointer;
  border-radius: 4px;

  img {
    position: absolute;
    width: 378px;
    height: 100%;
    border-radius: 4px;
    object-fit: cover; /* 或者使用contain, fill, none, scale-down等值 */
    object-position:95% 100%; /* 默认值，可以根据需要调整x和y坐标 */
    z-index: 1;
  }

  &__text {
    padding: 0px 30px;
    //writing-mode: vertical-lr;
    font-size: 22px;
    //font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 30px;
    z-index: 2;

  }
}
.item__title__detail_add{
  padding-top: 50px;
  font-size: 20px;
  padding-bottom: 10px;
}
.item__title__detail_add1{
  font-weight: normal;padding-top: 10px;
  font-size: 16px;
  i{
    margin-right: 10px;
  }
}
.item__title-active {
  width: 0;
  //background: linear-gradient(180deg, #ffbb1a 0%, #f57c00 100%);
}

@keyframes moveInRight {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}


</style>

